import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    breakpoint: {
        thresholds: {
            xs: 400,
            sm: 540,
            md: 960,
            lg: 1280,
        },
        scrollBarWidth: 24,
    },
});
